import {
  Input,
  Pagination,
  Select,
  Tooltip,
  Modal,
  Form,
  DatePicker,
  ConfigProvider,
  Spin,
} from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  ExclamationCircleFilled,
  SelectOutlined,
  CloseSquareOutlined,
  ExportOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { convertToObjectKeyString, TranslateString } from "Utils/Common";
import { useIntl } from "react-intl";
import { Button } from "react-bootstrap";
import moment from "moment";
import { BsArrowDownUp } from "react-icons/bs";
import { TenderStatus, monthOptions } from "constants/Constants";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import localeFI from "antd/lib/locale/fi_FI";
import localeEN from "antd/lib/locale/en_US";
import "moment/locale/fi";
import HousingCompanyService from "services/services/HousingCompanyService";

const HousingCompanyTable = (props: any) => {
  const cookies = new Cookies();
  const navigate = useNavigate();
  let targetGroupHousingcompany2 = cookies.get("target-group-housingcompany");
  const intl = useIntl();
  const [data, setData] = useState<any>();
  const [targetGroupHousingcompany, setTargetGroupHousingcompany] =
    useState<any>(targetGroupHousingcompany2);
  const [isModalOpen, setIsModalOpen] = useState<any>(false);
  const [modalData, setModalData] = useState<any>({});
  const [paginationData, setPaginationData] = useState<any>({
    page: 1,
    pageSize: 10,
  });
  const [loading, setLoading] = useState<any>(false);

  useEffect(() => {
    if (props?.data?.length > 0) {
      setData(props?.data);
      setPaginationData({ page: 1, pageSize: paginationData.pageSize });
    } else {
      setData([]);
    }
    // console.log(new Date())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const onSearch = (event: any) => {
    const { target } = event;
    const value = target.value;
    const { name } = target;

    setTargetGroupHousingcompany({
      ...targetGroupHousingcompany,
      [name]: value,
    });

    // NEW: Instantly trigger search in parent (this is the key line)
    props.setSearchData({ ...targetGroupHousingcompany, [name]: value });
  };

  const onPressEnter = (event: any) => {
    props.setSearchData({ ...targetGroupHousingcompany });
  };

  const onStatusChange = (value: any) => {
    props.setSearchData({ ...props.searchData, status: value });
    setTargetGroupHousingcompany({
      ...targetGroupHousingcompany,
      status: value,
    });
  };

  const onNextReferenceDateChange = (value: any) => {
    props.setSearchData({
      ...props.searchData,
      next_reference_data_check: value?.toString(),
    });
    setTargetGroupHousingcompany({
      ...targetGroupHousingcompany,
      next_reference_data_check: value?.toString(),
    });
  };

  const onSelectLoan = (data: any) => {
    Modal.confirm({
      title: intl.formatMessage({
        id: convertToObjectKeyString(
          "Are you sure you want to move this loan to the tendering list?",
        ),
      }),
      icon: <ExclamationCircleFilled />,
      // content: 'Some descriptions',
      okText: intl.formatMessage({ id: convertToObjectKeyString("Yes") }),
      okButtonProps: { className: "cu-btn-green rounded" },
      cancelText: intl.formatMessage({
        id: convertToObjectKeyString("Cancel"),
      }),
      cancelButtonProps: { className: "cu-border-green cu-text-green rounded" },
      onOk() {
        let objData: any = {};
        objData.loan_data_credit_id = data?.loan_data_credit_id;
        objData.loan_data_name = data?.loan_data_name;
        objData.loan_tender_status = "potential";

        props.selectLoanData(objData);
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
  };

  const onSelectSplitLoan = (data: any, action: any) => {
    Modal.confirm({
      title: intl.formatMessage({
        id: convertToObjectKeyString(
          "please_note_that_the_selected_loan_is_a_split_loan",
        ),
      }),
      icon: <ExclamationCircleFilled />,
      // content: 'Some descriptions',
      okText: intl.formatMessage({ id: convertToObjectKeyString("Yes") }),
      okButtonProps: { className: "cu-btn-green rounded" },
      cancelText: intl.formatMessage({ id: convertToObjectKeyString("No") }),
      cancelButtonProps: { className: "cu-border-green cu-text-green rounded" },
      onOk() {
        if (action === "select_loan") {
          let objData: any = {};
          objData.loan_data_credit_id = data?.loan_data_credit_id;
          objData.loan_data_name = data?.loan_data_name;
          objData.loan_tender_status = "potential";
          props.selectLoanData(objData);
        } else if (action === "dont_tender") {
          onDontTender(data);
        }
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
  };

  const onDontTender = (data: any) => {
    setIsModalOpen(!isModalOpen);
    setModalData(data);
  };

  const onFinishDontTender = (data: any) => {
    if (typeof data.loan_tender_deadline === "undefined") {
      delete data.loan_tender_deadline;
    } else {
      data.loan_tender_deadline = moment(data.loan_tender_deadline).format(
        "YYYY-MM-DD",
      );
    }
    let objData: any = {
      loan_data_credit_id: modalData?.loan_data_credit_id,
      loan_tender_status: "dont_tender",
      ...data,
    };
    if (props.finishDontTender(objData)) {
      setIsModalOpen(!isModalOpen);
    }
  };

  const splitLoanCheck = async (data: any, action: any) => {
    setLoading(true);
    let object: any = {};
    object.loan_data_credit_number = data?.loan_data_credit_number;
    object.loan_data_customerid = data?.loan_data_customerid;

    await HousingCompanyService.checkSplitLoan(object)
      .then((response: any) => {
        if (response?.data?.code === 200) {
          let loanCount = response?.data?.data?.loan_count || 0;
          if (loanCount > 1) {
            onSelectSplitLoan(data, action);
          } else if (loanCount <= 1 && action === "select_loan") {
            onSelectLoan(data);
          } else if (loanCount <= 1 && action === "dont_tender") {
            onDontTender(data);
          }
        }
        setLoading(false);
      })
      .catch((err: any) => {
        setLoading(false);
      });
  };

  const statusColor = (data: any) => {
    switch (data) {
      case "potential":
        return "#800000";
      case "proposed_for_tendering":
        return "#000000d9";
      case "not_fit_for_tendering":
        return "#808000";
      case "approved_for_tendering":
        return "#00c900";
      case "ongoing":
        return "#008000";
      case "loan_comparison_ongoing":
        return "#00FFFF";
      case "comparison_sent_to_ahc":
        return "#008080";
      case "bank_changes":
        return "#0000FF";
      case "bank_doesnot_change":
        return "#000080";
      case "invoiced":
        return "#FF00FF";
      case "tendering_declined":
        return "#800080";
      case "requested_for_tendering":
        return "#E67E22";
      default:
        return "#212529";
    }
  };

  const statusColorBg = (data: any) => {
    switch (data) {
      case "potential":
        return "#f1c5c5";
      case "proposed_for_tendering":
        return "#f6e985";
      case "not_fit_for_tendering":
        return "#eeee8a";
      case "approved_for_tendering":
        return "#c2f1c2";
      case "ongoing":
        return "#9ff39f";
      case "loan_comparison_ongoing":
        return "#adf7f7";
      case "comparison_sent_to_ahc":
        return "#abf5f5";
      case "bank_changes":
        return "#b6b6fc";
      case "bank_doesnot_change":
        return "#b6b6e4";
      case "invoiced":
        return "#f5abf5";
      case "tendering_declined":
        return "#feb2fe";
      case "requested_for_tendering":
        return "#fbd3b1";
      default:
        return "#afb6bd";
    }
  };

  return (
    <>
      <Spin spinning={loading}>
        <table className="table table-sm table-bordered table-striped cu-text-small">
          <thead>
            <tr className="align-middle">
              <th className="cu-bg-green text-center cu-three-width">
                {intl.formatMessage({
                  id: convertToObjectKeyString("Priority"),
                })}
              </th>
              <th className="cu-bg-green text-center cu-three-width">
                {intl.formatMessage({
                  id: convertToObjectKeyString("customer_id"),
                })}
              </th>
              <th className="cu-bg-green text-left">
                {intl.formatMessage({
                  id: convertToObjectKeyString("housing_company"),
                })}
              </th>
              <th className="cu-bg-green text-left cu-three-width">
                {intl.formatMessage({ id: convertToObjectKeyString("City") })}
              </th>
              <th className="cu-bg-green text-left">
                {intl.formatMessage({
                  id: convertToObjectKeyString("Loan Name"),
                })}
              </th>
              <th className="cu-bg-green text-left">
                {intl.formatMessage({
                  id: convertToObjectKeyString("loan_invoicing_model"),
                })}
              </th>
              <th className="cu-bg-green text-left">
                {intl.formatMessage({
                  id: convertToObjectKeyString("loan_number"),
                })}
              </th>
              <th className="cu-bg-green text-left">
                {intl.formatMessage({
                  id: convertToObjectKeyString("housing_manager"),
                })}
              </th>
              <th className="cu-bg-green text-right text-nowrap cu-three-width">
                {intl.formatMessage({
                  id: convertToObjectKeyString("Current Capital"),
                })}
              </th>
              <th className="cu-bg-green text-right cu-three-width">
                {intl.formatMessage({ id: convertToObjectKeyString("margin") })}
              </th>
              <th className="cu-bg-green text-left cu-three-width">
                {intl.formatMessage({
                  id: convertToObjectKeyString("loaner_group"),
                })}
              </th>
              <th className="cu-bg-green text-right cu-five-width">
                {intl.formatMessage({
                  id: convertToObjectKeyString("loan_time_left"),
                })}
              </th>
              <th className="cu-bg-green text-right cu-five-width">
                {intl.formatMessage({
                  id: convertToObjectKeyString("next_reference_date"),
                })}
              </th>
              <th className="cu-bg-green">
                {intl.formatMessage({ id: convertToObjectKeyString("status") })}
              </th>
              {/* <th className="cu-bg-green text-nowrap">{intl.formatMessage({ id: convertToObjectKeyString('Select Loan') })}</th>
                        <th className="cu-bg-green text-nowrap">{intl.formatMessage({ id: convertToObjectKeyString("Don't Tender") })}</th> */}
              <th className="cu-bg-green" colSpan={4}>
                {intl.formatMessage({
                  id: convertToObjectKeyString("Actions"),
                })}
              </th>
            </tr>
            <tr>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setSearchData({
                          ...props.searchData,
                          sort_by: "loan_data_priority",
                        });
                        props.setSort(!props.sort);
                      }}
                    />
                  }
                  onChange={onSearch}
                  //   onPressEnter={onPressEnter}
                  name="loan_data_priority"
                  value={targetGroupHousingcompany?.loan_data_priority || ""}
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setSearchData({
                          ...props.searchData,
                          sort_by: "loan_data_customerid",
                        });
                        props.setSort(!props.sort);
                      }}
                    />
                  }
                  onChange={onSearch}
                  //   onPressEnter={onPressEnter}
                  name="loan_data_customerid"
                  value={targetGroupHousingcompany?.loan_data_customerid || ""}
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setSearchData({
                          ...props.searchData,
                          sort_by: "loan_data_customername",
                        });
                        props.setSort(!props.sort);
                      }}
                    />
                  }
                  onChange={onSearch}
                  //   onPressEnter={onPressEnter}
                  name="loan_data_customername"
                  value={
                    targetGroupHousingcompany?.loan_data_customername || ""
                  }
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setSearchData({
                          ...props.searchData,
                          sort_by: "cust_data_city",
                        });
                        props.setSort(!props.sort);
                      }}
                    />
                  }
                  onChange={onSearch}
                  //   onPressEnter={onPressEnter}
                  name="cust_data_city"
                  value={targetGroupHousingcompany?.cust_data_city || ""}
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setSearchData({
                          ...props.searchData,
                          sort_by: "loan_data_name",
                        });
                        props.setSort(!props.sort);
                      }}
                    />
                  }
                  onChange={onSearch}
                  //   onPressEnter={onPressEnter}
                  name="loan_data_name"
                  value={targetGroupHousingcompany?.loan_data_name || ""}
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setSearchData({
                          ...props.searchData,
                          sort_by: "loan_invoicing_model",
                        });
                        props.setSort(!props.sort);
                      }}
                    />
                  }
                  onChange={onSearch}
                  name="loan_invoicing_model"
                  value={
                    targetGroupHousingcompany?.loan_invoicing_model || ""
                  }
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setSearchData({
                          ...props.searchData,
                          sort_by: "loan_data_credit_number",
                        });
                        props.setSort(!props.sort);
                      }}
                    />
                  }
                  onChange={onSearch}
                  //   onPressEnter={onPressEnter}
                  name="loan_data_credit_number"
                  value={
                    targetGroupHousingcompany?.loan_data_credit_number || ""
                  }
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setSearchData({
                          ...props.searchData,
                          sort_by: "cust_data_manager_name",
                        });
                        props.setSort(!props.sort);
                      }}
                    />
                  }
                  onChange={onSearch}
                  //   onPressEnter={onPressEnter}
                  name="cust_data_manager_name"
                  value={
                    targetGroupHousingcompany?.cust_data_manager_name || ""
                  }
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setSearchData({
                          ...props.searchData,
                          sort_by: "loan_data_agreement",
                        });
                        props.setSort(!props.sort);
                      }}
                    />
                  }
                  onChange={onSearch}
                  //   onPressEnter={onPressEnter}
                  name="loan_data_agreement"
                  value={targetGroupHousingcompany?.loan_data_agreement || ""}
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setSearchData({
                          ...props.searchData,
                          sort_by: "loan_data_margin",
                        });
                        props.setSort(!props.sort);
                      }}
                    />
                  }
                  onChange={onSearch}
                  //   onPressEnter={onPressEnter}
                  name="loan_data_margin"
                  value={targetGroupHousingcompany?.loan_data_margin || ""}
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setSearchData({
                          ...props.searchData,
                          sort_by: "loan_data_bank_group",
                        });
                        props.setSort(!props.sort);
                      }}
                    />
                  }
                  onChange={onSearch}
                  //   onPressEnter={onPressEnter}
                  name="loan_data_bank_group"
                  value={targetGroupHousingcompany?.loan_data_bank_group || ""}
                />
              </td>
              <td className="cu-bg-green" width={100}>
                <Input
                  placeholder={TranslateString("search")}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setSearchData({
                          ...props.searchData,
                          sort_by: "loan_data_date_diff",
                        });
                        props.setSort(!props.sort);
                      }}
                    />
                  }
                  onChange={onSearch}
                  //   onPressEnter={onPressEnter}
                  name="loan_data_date_diff"
                  value={targetGroupHousingcompany?.loan_data_date_diff || ""}
                />
              </td>
              <th className="cu-bg-green text-right cu-five-width">
                {(() => {
                  let filterSelectProps: any = {
                    showSearch: true,
                    allowClear: true,
                    className: "w-100",
                    mode: "multiple",
                    onChange: onNextReferenceDateChange,
                    options: [
                      ...monthOptions.map(({ value, label }) => {
                        return {
                          value: value,
                          label: intl.formatMessage({
                            id: convertToObjectKeyString(label),
                          }),
                        };
                      }),
                    ],
                  };
                  if (props?.searchData?.next_reference_data_check) {
                    filterSelectProps.defaultValue =
                      props?.searchData?.next_reference_data_check
                        ?.split(",")
                        ?.map((month: any) => {
                          return (
                            monthOptions.find(
                              (f) => Number(f.value) === Number(month),
                            ) || false
                          );
                        });
                  }
                  return <Select {...filterSelectProps} />;
                })()}
              </th>
              <td className="cu-bg-green" width={100}>
                <Select
                  showSearch
                  defaultValue={targetGroupHousingcompany?.status || "all"}
                  className="w-100"
                  onChange={onStatusChange}
                  options={[
                    ...TenderStatus.map(({ value, label }) => {
                      return {
                        value: value,
                        label: intl.formatMessage({
                          id: convertToObjectKeyString(value),
                        }),
                      };
                    }),
                  ]}
                />
              </td>
              {/* <td className="cu-bg-green" width={100}></td>
                        <td className="cu-bg-green" width={120}></td> */}
              <td className="cu-bg-green" width={90} colSpan={4}></td>
            </tr>
          </thead>
          <tbody>
            {(() => {
              let startFrom =
                paginationData.pageSize * (paginationData.page - 1);
              let endFrom = startFrom + paginationData.pageSize;
              return data
                ?.slice(startFrom, endFrom)
                .map((element: any, index: any) => {
                  return (
                    <tr key={Math.random()}>
                      <td
                        className="text-center fw-bold"
                        onClick={() =>
                          navigate(
                            `/housingcompaies-analysis/${element.loan_data_customerid}/${element.loan_data_customername.replace(/\//g, "----")}`,
                          )
                        }
                      >
                        {element?.loan_data_priority}
                      </td>
                      <td
                        className={
                          element?.reload_customer
                            ? "text-center fw-bold cu-font-cancel"
                            : "text-center fw-bold"
                        }
                        onClick={() =>
                          navigate(
                            `/housingcompaies-analysis/${element.loan_data_customerid}/${element.loan_data_customername.replace(/\//g, "----")}`,
                          )
                        }
                      >
                        {element?.loan_data_customerid}
                      </td>
                      <td className="text-left">
                        <Link
                          style={{ color: "#000000" }}
                          to={`/housingcompaies-analysis/${element.loan_data_customerid}/${element.loan_data_customername.replace(/\//g, "----")}`}
                          replace
                        >
                          {element?.loan_data_customername}
                        </Link>
                      </td>
                      <td
                        className="text-left"
                        onClick={() =>
                          navigate(
                            `/housingcompaies-analysis/${element.loan_data_customerid}/${element.loan_data_customername.replace(/\//g, "----")}`,
                          )
                        }
                      >
                        {element?.CUST_DATA?.cust_data_city}
                      </td>
                      <td
                        className="text-left"
                        onClick={() =>
                          navigate(
                            `/housingcompaies-analysis/${element.loan_data_customerid}/${element.loan_data_customername.replace(/\//g, "----")}`,
                          )
                        }
                      >
                        {element?.loan_data_name?.replace(
                          "Uusi laina:",
                          TranslateString("new_loan"),
                        ) || ""}
                      </td>
                      <td
                        className="text-left"
                        onClick={() =>
                          navigate(
                            `/housingcompaies-analysis/${element.loan_data_customerid}/${element.loan_data_customername.replace(/\//g, "----")}`,
                          )
                        }
                      >
                        {element?.loan_invoicing_model}
                      </td>
                      <td
                        className="text-left"
                        onClick={() =>
                          navigate(
                            `/housingcompaies-analysis/${element.loan_data_customerid}/${element.loan_data_customername.replace(/\//g, "----")}`,
                          )
                        }
                      >
                        {element?.loan_data_credit_number}
                      </td>
                      <td
                        className="text-left"
                        onClick={() =>
                          navigate(
                            `/housingcompaies-analysis/${element.loan_data_customerid}/${element.loan_data_customername.replace(/\//g, "----")}`,
                          )
                        }
                      >
                        {element?.CUST_DATA?.cust_data_manager_name}
                      </td>
                      <td
                        className="text-right fw-bold text-nowrap"
                        onClick={() =>
                          navigate(
                            `/housingcompaies-analysis/${element.loan_data_customerid}/${element.loan_data_customername.replace(/\//g, "----")}`,
                          )
                        }
                      >
                        {element?.loan_data_agreement}
                      </td>
                      <td
                        className="text-right fw-bold text-nowrap"
                        onClick={() =>
                          navigate(
                            `/housingcompaies-analysis/${element.loan_data_customerid}/${element.loan_data_customername.replace(/\//g, "----")}`,
                          )
                        }
                      >
                        {element?.loan_data_margin}
                      </td>
                      <td
                        className="text-left"
                        onClick={() =>
                          navigate(
                            `/housingcompaies-analysis/${element.loan_data_customerid}/${element.loan_data_customername.replace(/\//g, "----")}`,
                          )
                        }
                      >
                        {element?.loan_data_bank_group}
                      </td>
                      <td
                        className="text-right fw-bold"
                        onClick={() =>
                          navigate(
                            `/housingcompaies-analysis/${element.loan_data_customerid}/${element.loan_data_customername.replace(/\//g, "----")}`,
                          )
                        }
                      >
                        {element?.loan_data_period}
                      </td>
                      <th
                        className="text-right fw-bold text-nowrap"
                        onClick={() =>
                          navigate(
                            `/housingcompaies-analysis/${element.loan_data_customerid}/${element.loan_data_customername.replace(/\//g, "----")}`,
                          )
                        }
                      >
                        {element?.next_reference_data_check}
                      </th>
                      <td
                        onClick={() =>
                          navigate(
                            `/housingcompaies-analysis/${element.loan_data_customerid}/${element.loan_data_customername.replace(/\//g, "----")}`,
                          )
                        }
                      >
                        {element?.LOAN_TENDER?.loan_tender_status ? (
                          <h6>
                            <span
                              className="badge text-uppercase"
                              style={{
                                background: statusColorBg(
                                  element?.LOAN_TENDER?.loan_tender_status,
                                ),
                                color: statusColor(
                                  element?.LOAN_TENDER?.loan_tender_status,
                                ),
                              }}
                            >
                              {TranslateString(
                                element?.LOAN_TENDER?.loan_tender_status,
                              ) || ""}
                            </span>
                          </h6>
                        ) : (
                          ""
                        )}
                      </td>
                      <td>
                        {
                          <Tooltip
                            placement="topLeft"
                            title={intl.formatMessage({
                              id: convertToObjectKeyString("select_loan"),
                            })}
                          >
                            <SelectOutlined
                              onClick={() => {
                                splitLoanCheck(element, "select_loan");
                              }}
                              disabled={
                                element?.LOAN_TENDER?.loan_tender_status
                                  ? true
                                  : false
                              }
                              className="m-0 cu-font-bold cu-font-select"
                            />
                          </Tooltip>
                        }
                      </td>
                      <td>
                        {
                          <Tooltip
                            placement="topLeft"
                            title={intl.formatMessage({
                              id: convertToObjectKeyString("dont_tender"),
                            })}
                          >
                            <CloseSquareOutlined
                              onClick={() => {
                                splitLoanCheck(element, "dont_tender");
                              }}
                              disabled={
                                element?.LOAN_TENDER?.loan_tender_status
                                  ? true
                                  : false
                              }
                              className="m-0 cu-font-bold cu-font-cancel"
                            />
                          </Tooltip>
                        }
                      </td>
                      <td>
                        {
                          <Tooltip
                            placement="topLeft"
                            title={intl.formatMessage({
                              id: convertToObjectKeyString("transformation"),
                            })}
                          >
                            <ReloadOutlined
                              onClick={() => {
                                props?.transformCustomer(element);
                              }}
                              className="m-0 cu-font-bold"
                            />
                          </Tooltip>
                        }
                      </td>
                      <td>
                        <Tooltip
                          placement="topLeft"
                          title={intl.formatMessage({
                            id: convertToObjectKeyString("Export"),
                          })}
                        >
                          <Link
                            to={
                              "/generate-pdf/" +
                              element?.loan_data_customerid +
                              "/" +
                              element?.loan_data_id
                            }
                            target="_blank"
                          >
                            <ExportOutlined className="m-0 cu-font-bold cu-font-export text-dark" />
                          </Link>
                        </Tooltip>
                      </td>
                    </tr>
                  );
                });
            })()}
          </tbody>
        </table>
      </Spin>
      <div className="d-flex justify-content-between pb-2">
        <div></div>
        <div>
          <Pagination
            defaultCurrent={1}
            current={props?.pageData?.page + 1}
            pageSize={paginationData.pageSize}
            total={props?.totalRecords || 0}
            pageSizeOptions={[10, 20, 50, 100]}
            locale={{ items_per_page: `${intl.formatMessage({ id: "page" })}` }}
            showTotal={(total: any, range: any) =>
              `${range[0]}-${range[1]} ${intl.formatMessage({ id: "of" })} ${total} ${intl.formatMessage({ id: "items" })}`
            }
            showSizeChanger={true}
            onShowSizeChange={(page: any, pageSize: any) => {
              setPaginationData({
                ...paginationData,
                pageSize: pageSize,
              });
              props?.setPageData({
                size: pageSize,
                page: paginationData.pageSize !== pageSize ? 0 : page - 1,
              });
            }}
            onChange={(page: any, pageSize: any) => {
              setPaginationData({
                pageSize: pageSize,
                page: page,
              });
              props?.setPageData({
                size: pageSize,
                page: paginationData.pageSize !== pageSize ? 0 : page - 1,
              });
            }}
          />
        </div>
      </div>
      <Modal
        open={isModalOpen}
        destroyOnClose
        footer={false}
        onCancel={() => setIsModalOpen(!isModalOpen)}
      >
        <Form
          requiredMark={false}
          name={intl.formatMessage({
            id: convertToObjectKeyString("dont_tender"),
          })}
          onFinish={onFinishDontTender}
          layout="vertical"
          initialValues={{}}
        >
          <ConfigProvider locale={intl.locale === "en" ? localeEN : localeFI}>
            <Form.Item
              label={intl.formatMessage({
                id: convertToObjectKeyString("Deadline Date"),
              })}
              name="loan_tender_deadline"
              className="my-1"
            >
              <DatePicker
                format={"DD.MM.YYYY"}
                className="w-100"
                placeholder={intl.formatMessage({
                  id: convertToObjectKeyString("Select Date"),
                })}
              />
            </Form.Item>
          </ConfigProvider>

          <Form.Item
            label={
              <>
                <span>
                  {intl.formatMessage({
                    id: convertToObjectKeyString("Reason"),
                  })}
                </span>
                <span className="text-danger">*</span>
              </>
            }
            name="loan_tender_notes"
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: convertToObjectKeyString("Please input your Reason!"),
                }),
              },
            ]}
            className="mb-1"
          >
            <Input.TextArea />
          </Form.Item>
          <div className="d-flex justify-content-end">
            <Button
              type="reset"
              className="btn btn-sm bg-secondary px-4 border-secondary"
              onClick={props.handleReset}
            >
              {TranslateString("reset")}
            </Button>
            &nbsp;
            <Button type="submit" className="btn btn-sm cu-btn-green px-3">
              {TranslateString("Submit")}
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default HousingCompanyTable;
